"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _lodash = _interopRequireDefault(require("lodash"));
var _json = _interopRequireDefault(require("json5"));
var ConfigLoader = exports.default = /*#__PURE__*/function () {
  function ConfigLoader() {
    (0, _classCallCheck2.default)(this, ConfigLoader);
    this.config = Object.create(null);
    this.valReplacements = Object.create(null);
  }
  return (0, _createClass2.default)(ConfigLoader, [{
    key: "addValueReplacement",
    value: function addValueReplacement(key, value) {
      this.valReplacements[key] = value;
      return this;
    }
  }, {
    key: "loadFromUrl",
    value: function loadFromUrl(configUrl) {
      var _this = this;
      return fetch(configUrl).then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP error ' + response.status);
        }
        return response.text();
      }).then(function (text) {
        var configObj = _json.default.parse(text);
        _this.setConfig(configObj);
        return _this.config;
      });
    }
  }, {
    key: "loadFromObj",
    value: function loadFromObj(configObj) {
      var _this2 = this;
      return new _promise.default(function (resolve, reject) {
        _this2.setConfig(configObj);
        resolve(_this2.config);
      });
    }
  }, {
    key: "setConfig",
    value: function setConfig(confObj) {
      var _this3 = this;
      var _walkObject = function walkObject(obj, target) {
        _lodash.default.each(obj, function (_val, key) {
          var val = _val;
          if (typeof val === 'string') {
            val = _this3.insertReplacements(val);
            target[key] = val;
          } else if ((0, _typeof2.default)(val) === 'object') {
            target[key] = _lodash.default.isArray(val) ? [] : {};
            _walkObject(val, target[key]);
          } else {
            target[key] = val;
          }
        });
      };
      this.config = Object.create(null);
      _walkObject(confObj, this.config);
    }
  }, {
    key: "insertReplacements",
    value: function insertReplacements(input) {
      var out = input;
      var keys = (0, _keys.default)(this.valReplacements);
      for (var i = 0; i < keys.length; i++) {
        var k = keys[i];
        if (input === '{{' + k + '}}') {
          // If we have an exact match, return the exact replacement value we have as
          // it may not be a string
          return this.valReplacements[k];
        }
        out = out.replace('{{' + k + '}}', this.valReplacements[k]);
      }
      return out;
    }
  }]);
}();
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ConfigLoader"]
window._kiwi_exports.libs.ConfigLoader = exports.default ? exports.default : exports;
